import { Box, Button, Group, Modal, Pill, Stack, Text, Tooltip } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconTrash as IconDelete } from '@tabler/icons-react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useRemoveAlias } from '@/module/Dashboard/model/DashboardQuery';

import { useAppNotification, useDelete } from '@feature/utils';

interface AliasPillProps {
  alias: string;
}

export function AliasPill(props: AliasPillProps) {
  const { alias } = props;
  const [opened, { open, close }] = useDisclosure(false);
  const { t } = useTranslation();
  const mutation = useRemoveAlias({ alias });
  const { isDeleting, onDelete } = useDelete({ mutation, navigateTo: null });
  const notification = useAppNotification();

  const handleOnClick = useCallback(() => {
    navigator.clipboard
      .writeText(alias)
      .then(() => {
        notification.success();
      })
      .catch(err => {
        notification.error(err);
      });
  }, [alias, notification]);
  return (
    <Box
      style={{ cursor: 'pointer' }}
      onClick={handleOnClick}
    >
      <Pill
        withRemoveButton
        onRemove={open}
        removeButtonProps={{ 'aria-label': t('profile.alias.remove', { alias }), 'aria-hidden': false }}
        key={alias}
      >
        <Tooltip label={t('tooltip.copyClipboard')}>
          <Text
            span
            size="xs"
          >
            {alias}
          </Text>
        </Tooltip>
      </Pill>
      <Modal
        opened={opened}
        onClose={close}
        title={t('profile.removeAliasConfirm.title')}
        centered
      >
        <Stack>
          <Text
            style={{ textAlign: 'center' }}
            fw="500"
          >
            {t('profile.removeAliasConfirm.content')}
          </Text>
          <Group justify="flex-end">
            <Button
              variant="outline"
              onClick={close}
              loading={isDeleting}
            >
              {t('button.cancel')}
            </Button>
            <Button
              onClick={onDelete}
              bg="red"
              loading={isDeleting}
              leftSection={<IconDelete size={16} />}
            >
              {t('button.delete')}
            </Button>
          </Group>
        </Stack>
      </Modal>
    </Box>
  );
}
